
import telephoneMask from '~/lib/input-masks/telephone'

export default {
  name: 'InputTelephone',

  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      telephoneNumber: '',
      activeCountryCode: 'GB',
      telephoneMask
    }
  },

  computed: {
    compValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    compCountryOptions() {
      return [
        {
          label: '+44',
          value: 'GB'
        }
      ]
    }
  }
}
